import React from 'react';
import { TileIds, TileRules } from '../../../../util/tileEnums';
import {
  BcbsCaModalValue,
  BcbsModalValue,
  BcbsTxModalValue,
} from '../../../components/InsuranceHelpModal/modalValues';
import { InsurerCodes } from '../../../../../../../constants/insurance';

export const bcbsInsightTiles = [
  {
    id: TileIds.INSURANCE_INSIGHT_NURSE_HOTLINE,
    header: 'Call Anytime',
    description: () => `Access to a 24/7 nurse hotline`,
    rules: [TileRules.IS_INSURANCE_BCBS, TileRules.IS_NOT_CHILD],
    modalValue: BcbsModalValue.NURSE_HOTLINE,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_CA]: 1, [InsurerCodes.BLUE_SHIELD_TX]: 1 },
  },
];

export const bcbsCaInsightTiles = [
  {
    id: TileIds.INSURANCE_INSIGHT_THERAPEUTIC_MASSAGE,
    header: 'Loosen Up',
    description: () => `25% off select massage therapists`,
    rules: [TileRules.IS_INSURANCE_BCBS_CA, TileRules.IS_NOT_CHILD],
    modalValue: BcbsCaModalValue.THERAPEUTIC_MASSAGE,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_CA]: 6 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_CHIROPRACTOR,
    header: 'Get Aligned',
    description: () => `Discount on select chiropractors`,
    rules: [TileRules.IS_INSURANCE_BCBS_CA, TileRules.IS_NOT_CHILD],
    modalValue: BcbsCaModalValue.CHIROPRACTOR,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_CA]: 9 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_VITAMIX_BLENDER,
    header: 'Smoothies For Days',
    description: () => 'Up to $160 off Vitamix blenders',
    rules: [TileRules.IS_INSURANCE_BCBS_CA, TileRules.IS_NOT_CHILD],
    modalValue: BcbsCaModalValue.VITAMIX_BLENDER,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_CA]: 4 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_ACUPUNCTURE,
    header: 'Stick It To Me',
    description: () => 'Discounts on select acupuncturists',
    rules: [TileRules.IS_INSURANCE_BCBS_CA, TileRules.IS_NOT_CHILD],
    modalValue: BcbsCaModalValue.ACUPUNCTURE,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_CA]: 12 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_GYM_MEMBERSHIP,
    header: 'Work It Out',
    description: () => `$25 memberships at select gyms`,
    rules: [TileRules.IS_INSURANCE_BCBS_CA, TileRules.IS_NOT_CHILD],
    modalValue: BcbsCaModalValue.GYM_MEMBERSHIP,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_CA]: 2 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_FLU_SHOT,
    header: 'Free Flu Shots',
    description: () => `Get your annual flu shot at select locations`,
    rules: [TileRules.IS_INSURANCE_BCBS_CA, TileRules.IS_NOT_CHILD],
    modalValue: BcbsCaModalValue.FLU_SHOT,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_CA]: 7 },
  },
];

export const bcbsTxInsightTiles = [
  {
    id: TileIds.INSURANCE_INSIGHT_GARMIN,
    header: 'Step Up',
    description: () => `Up to 35% off Garmin devices`,
    rules: [TileRules.IS_INSURANCE_BCBS_TX, TileRules.IS_NOT_CHILD],
    modalValue: BcbsTxModalValue.GARMIN,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_TX]: 4 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_JENNY_CRAIG,
    header: 'Get Healthy',
    description: () => `Free 3 month membership at Jenny Craig and $120 in food credits`,
    rules: [TileRules.IS_INSURANCE_BCBS_TX, TileRules.IS_NOT_CHILD],
    modalValue: BcbsTxModalValue.JENNY_CRAIG,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_TX]: 8 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_LASIK,
    header: 'See Things Clearly',
    description: () => `Up to $800 off LASIK at LasikPlus in-network provider`,
    rules: [TileRules.IS_INSURANCE_BCBS_TX, TileRules.IS_NOT_CHILD],
    modalValue: BcbsTxModalValue.LASIK,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_TX]: 11 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_GYM_MEMBERSHIP,
    header: 'Work It Out',
    description: () => `$25 memberships at select gyms`,
    rules: [TileRules.IS_INSURANCE_BCBS_TX, TileRules.IS_NOT_CHILD],
    modalValue: BcbsTxModalValue.GYM_MEMBERSHIP,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_TX]: 2 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_FLU_SHOT,
    header: 'Free Flu Shots',
    description: () => `Get your annual flu shot at select locations`,
    rules: [TileRules.IS_INSURANCE_BCBS_TX, TileRules.IS_NOT_CHILD],
    modalValue: BcbsTxModalValue.FLU_SHOT,
    sortOrder: { [InsurerCodes.BLUE_SHIELD_TX]: 6 },
  },
];
